var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocus2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 37.5V30C9.5 29.337 9.76339 28.7011 10.2322 28.2322C10.7011 27.7634 11.337 27.5 12 27.5H42C42.663 27.5 43.2989 27.7634 43.7678 28.2322C44.2366 28.7011 44.5 29.337 44.5 30V37.5M27 27.5V17.5M39.5 37.5H49.5C50.8807 37.5 52 38.6193 52 40V50C52 51.3807 50.8807 52.5 49.5 52.5H39.5C38.1193 52.5 37 51.3807 37 50V40C37 38.6193 38.1193 37.5 39.5 37.5ZM4.5 37.5H14.5C15.8807 37.5 17 38.6193 17 40V50C17 51.3807 15.8807 52.5 14.5 52.5H4.5C3.11929 52.5 2 51.3807 2 50V40C2 38.6193 3.11929 37.5 4.5 37.5ZM22 2.5H32C33.3807 2.5 34.5 3.61929 34.5 5V15C34.5 16.3807 33.3807 17.5 32 17.5H22C20.6193 17.5 19.5 16.3807 19.5 15V5C19.5 3.61929 20.6193 2.5 22 2.5Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus2);
export default __webpack_public_path__ + "static/media/focus-2.9f343bf1763b87ad3745b5d796e77141.svg";
export { ForwardRef as ReactComponent };